export default __webpack_public_path__ + "static/media/ShieldedMetalArcWeldingImg.d1b0266d.jpg";